import { interaction, SizableText, XStack, YStack } from '@mythical/ui'
import { SmartLink } from 'app/components/primitive/SmartLink'
import { TextLink } from 'app/components/primitive/TextLink'
import { Container } from '../Container'
import { LogoPink } from '../Navigation/Logo'
import { useStores } from 'app/store'

const footerLinks = [
  {
    label: 'Contact',
    href: '/contact',
  },
  {
    label: 'Privacy Policy',
    href: '/pages/privacy',
  },
  {
    label: 'FAQ',
    href: '/pages/faqs',
  },
  {
    label: 'Terms of Service',
    href: '/pages/terms',
  },
  {
    label: 'Perks',
    href: '/perks',
    requiresMemberfulLink: true,
  },
]

const Footer = () => {
  const { userStore } = useStores()
  const canMemberfulLink = userStore?.canMemberfulLink ?? false
  return (
    <Container
      tag="footer"
      variant="full"
      bg="$bgPrimary"
      gap="$8"
      py="$5"
      paddedX
    >
      <XStack
        ai="flex-start"
        flexDirection="column"
        gap="$8"
        mx="auto"
        w="100%"
        $gtMd={{ justifyContent: 'space-between', flexDirection: 'row' }}
      >
        <YStack gap="$8" w="100%" $gtMd={{ gap: '$5', maw: 464 }}>
          <SmartLink
            href="/"
            Component={LogoPink}
            aria-label="Back to homepage"
            {...interaction.opacity}
          />
          <SizableText
            color="$brandPink"
            fontFamily="$body"
            fontWeight="500"
            size="$4"
          >
            Exclusive videos, behind-the-scenes access, and member-only perks —
            made for the most dedicated Mythical fans.
          </SizableText>
        </YStack>

        <XStack f={1} flexWrap="wrap" rowGap="$5" $gtMd={{ rowGap: '$7' }}>
          {footerLinks
            .filter((link) => !link.requiresMemberfulLink || canMemberfulLink)
            .map((link) => (
              <TextLink
                color="$brandPink"
                href={link.href}
                key={link.href}
                size="$3.5"
                textTransform="uppercase"
                width="50%"
                fow="500"
                {...interaction.opacity}
              >
                {link.label}
              </TextLink>
            ))}
        </XStack>
      </XStack>

      <SizableText
        color="$brandPink"
        fontFamily="$body"
        fontWeight="500"
        size="$4"
      >
        © {new Date().getFullYear()} Mythical Entertainment. All rights
        reserved.
      </SizableText>
    </Container>
  )
}

export default Footer
